export const version = '3.3.9'
export const name = 'js-libp2p'
